(function () {
  function initCollectionSpotlight(section) {
    const track = section.querySelector('[data-ff-collection-track]');
    const prevBtn = section.querySelector('[data-ff-collection-prev]');
    const nextBtn = section.querySelector('[data-ff-collection-next]');

    if (!track || !prevBtn || !nextBtn) return;

    const scrollStep = () => {
      const item = track.querySelector('.ff-collection-tile');
      if (!item) return track.clientWidth * 0.85;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.offsetWidth + gap;
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
  }

  function initAll() {
    document.querySelectorAll('.ff-collection-spotlight').forEach(initCollectionSpotlight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.ff-collection-spotlight') || event.target;
    if (section && section.classList.contains('ff-collection-spotlight')) {
      initCollectionSpotlight(section);
    }
  });
})();
